import api from "./base/API.js";

const visitAnswerResource = "VisitStudyQuestionAnswer";
export default {
	sendAnswers(idMuseum, answers) {
		return api.post(visitAnswerResource +  '/' + idMuseum + '/registerAnswers', answers);
	},
};
